import calculatePresentationValues from 'helpers/presentation/calculatePresentationValues'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'

export default function updatePresentationValues(state, action) {
  const { key, value, fromMap, skipRoundFocal } = action
  const camera = getCurrentCamera(state.cameras)

  if (!camera) return state

  const presentationValues = calculatePresentationValues({
      camera,
      prevPresentationValues: state.presentationValues,
      fromMap,
      key,
      value,
      skipRoundFocal
    })

  return Object.assign({}, state, { presentationValues })
}



// WEBPACK FOOTER //
// ./src/reducers/updatePresentationValues.js